import { ActivatableApp } from '@vendasta/marketplace-packages';
import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface AppListingServiceInterface {
  listAllActivatableApps(): Observable<ActivatableApp[]>;
}

export const EMAIL_BUILDER_APP_LISTING_SERVICE_TOKEN = new InjectionToken<AppListingServiceInterface>(
  '[AppListingServiceInterface]: token for app listing service',
);
